import React from "react";
import Button from "@/components/ui/Button.jsx";
import Card from "@/components/ui/Card.jsx";
import Radio from "@/components/ui/Radio.jsx";

export function PaymentDetailsHeader({ eyebrow = "Payment details", title = "How would you like to pay?" }) {
  return (
    <div>
      <div className="text-title-medium text-primary">{eyebrow}</div>
      <div className="mt-2 text-title-large text-on-surface">{title}</div>
    </div>
  );
}

export function CheckoutPaymentMethodRow({ title, helper, selected, onClick, disabled = false, children }) {
  return (
    <Card
      as="button"
      type="button"
      aria-pressed={selected}
      disabled={disabled}
      onClick={onClick}
      className={[
        "flex min-h-[88px] w-full min-w-0 items-start gap-3 border-0 px-4 py-3 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--afrimed-primary))] focus-visible:ring-offset-2",
        selected
          ? "bg-[rgba(var(--afrimed-primary),0.08)] shadow-[var(--elev-2)]"
          : "bg-[rgb(var(--clr-surface)] hover:bg-[rgb(var(--clr-surface-cont-highest))]",
      ].join(" ")}
    >
      <Radio checked={selected} readOnly variant="afrimed" className="mt-0.5 shrink-0" />
      <span className="min-w-0 flex-1">
        <span className="block text-title-medium text-on-surface">{title}</span>
        {helper ? <span className="mt-1 block text-body-medium text-on-surface-var">{helper}</span> : null}
        {children}
      </span>
    </Card>
  );
}

// Rendered only by callers that have explicitly established DEV/Test mode.
// This never creates a payment method or writes card data to AfriMed™.
export function TestPaymentHelper({
  onSelected,
  onRunTest,
  running = false,
}) {
  return (
    <div className="rounded-[12px] border border-dashed border-[rgba(var(--afrimed-primary),0.55)] bg-[rgba(var(--afrimed-primary),0.05)] p-4">
      <div className="text-title-small text-on-surface">Test payment</div>
      <div className="mt-1 text-body-small text-on-surface-var">
        Use this only in the AfriMed™ Test environment. No real charge will be made.
      </div>
      {onRunTest ? (
        <div className="mt-3 flex flex-wrap items-center gap-3">
          {onRunTest ? <Button type="button" className="h-10 px-4" onClick={() => { onSelected?.(); onRunTest(); }} disabled={running}>
            {running ? "Opening secure payment…" : "Continue with test payment"}
          </Button> : null}
        </div>
      ) : null}
    </div>
  );
}
